"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _UserIdentityButton = _interopRequireDefault(require("../UserIdentityButton/UserIdentityButton"));

var _UserIdentityModal = _interopRequireDefault(require("../UserIdentityModal/UserIdentityModal"));

var UserIdentitySelector =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UserIdentitySelector, _React$Component);

  function UserIdentitySelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UserIdentitySelector);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserIdentitySelector).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      showModal: false
    };
    return _this;
  }

  (0, _createClass2.default)(UserIdentitySelector, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          identityId = _this$props.identityId,
          identityType = _this$props.identityType;

      if (identityId === null || identityType === null) {
        this.onOpenModal();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      var identityId = props.identityId,
          identityType = props.identityType;

      if (identityId === null || identityType === null) {
        this.onOpenModal();
      }
    }
  }, {
    key: "onCloseModal",
    value: function onCloseModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "onOpenModal",
    value: function onOpenModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "onSaveModal",
    value: function onSaveModal(identityId, identityType) {
      this.setState({
        showModal: false
      });
      this.props.onChangeIdentity(identityId, identityType);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          identityId = _this$props2.identityId,
          identityName = _this$props2.identityName,
          identityType = _this$props2.identityType,
          fulfillers = _this$props2.fulfillers,
          fulfillerOrder = _this$props2.fulfillerOrder,
          merchants = _this$props2.merchants,
          merchantOrder = _this$props2.merchantOrder;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UserIdentityModal.default, {
        identityId: identityId,
        identityType: identityType,
        fulfillers: fulfillers,
        fulfillerOrder: fulfillerOrder,
        merchants: merchants,
        merchantOrder: merchantOrder,
        show: this.state.showModal,
        onClose: this.onCloseModal,
        onSave: this.onSaveModal
      }), _react.default.createElement(_UserIdentityButton.default, {
        identityId: identityId,
        identityName: identityName,
        onOpen: this.onOpenModal
      }));
    }
  }]);
  return UserIdentitySelector;
}(_react.default.Component);

var _default = UserIdentitySelector;
exports.default = _default;